import React, { useEffect, useState } from "react";
import { Card, CardBody, Modal, Placeholder } from "react-bootstrap";
import "./index.css";
import { Col, Row } from "reactstrap";
import { useLazyGetWalletDetailsQuery, useUpdateCartPersonWalletMutation } from "../../../../redux/services/cartSearchService";
import { CartPersonData } from "../..";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromBracket, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ButtonComponent from "../../../../components/ButtonComponent";
import { toast } from "react-toastify";

interface CartPersonDetailsProps {
  cartPerson: CartPersonData | undefined;
}

const Wallet: React.FC<CartPersonDetailsProps> = ({ cartPerson }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [amount, setAmount] = useState("");

  const [
    triggerWalletData,
    { data: walletData, isLoading: isWalletDataLoading, error: walletDataError },
  ] = useLazyGetWalletDetailsQuery();

  useEffect(() => {
    if (cartPerson?.id) {
      triggerWalletData(cartPerson?.id);
    }
  }, [triggerWalletData, cartPerson?.id]);

  // Modal handlers
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAmount("");
  };

  const [updateCartPersonWallet] = useUpdateCartPersonWalletMutation();
  const handleUpdateWalletDetails = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!cartPerson?.merchantId) {
      toast.error("Merchant ID is missing");
      return;
    }

    const obj = {
      merchantId: cartPerson.merchantId || "",
      amount: parseFloat(amount),
    };

    try {
      setIsSaving(true);
      await updateCartPersonWallet(obj).unwrap();
      toast.success("Wallet Top up Successfully");
      triggerWalletData(cartPerson?.id)
      setIsSaving(false);
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to top up wallet");
      setIsSaving(false);
    }
  };

  return (
    <div className="carts-view-wallet-whole-body">
      {isWalletDataLoading ? (<>
        <div className='d-flex justify-content-center'>
          <Placeholder animation="glow">
            <Placeholder xs={6} />
          </Placeholder></div>
        <Card className="carts-view-wallet-upper-cards-left-card">
          <CardBody>
            <Row>
              <Col lg={4}>
                <Card className="carts-view-wallet-first-card p-2">
                  <CardBody>
                    <Placeholder animation="glow">
                      <Placeholder xs={6} />
                      <Placeholder xs={6} />
                    </Placeholder>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4}>
                <Card className='carts-view-wallet-second-card p-2'>
                  <CardBody>
                    <Placeholder animation="glow">
                      <Placeholder xs={6} />
                      <Placeholder xs={6} />
                    </Placeholder>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4}>
                <Card className='carts-view-wallet-third-card px-0 py-3'>
                  <CardBody>
                    <Placeholder animation="glow">
                      <Placeholder xs={6} />
                      <Placeholder xs={6} />
                    </Placeholder>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <Col lg={4}>
            <Card className='carts-view-wallet-second-card p-2'>
              <CardBody>
                <Placeholder animation="glow">
                  <Placeholder xs={6} />
                  <Placeholder xs={6} />
                </Placeholder>
              </CardBody>
            </Card>
          </Col>
        </Row></>) : (<> <Row>
          <Col lg={4}>
            <Card className="carts-view-wallet-upper-cards-left-card-left-card">
              <CardBody>
                <h6>Available Balance</h6>
                <h4>
                  {isWalletDataLoading
                    ? "Loading..."
                    : `LKR ${walletData?.purchaseWalletBalance ?? 0}`}
                </h4>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="carts-view-wallet-upper-cards-left-card-right-card">
              <CardBody>
                <h6>Credit Limit</h6>
                <h4>LKR 5000</h4>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="carts-view-wallet-upper-cards-left-card-right-card-top-up">
              <CardBody>
                <div
                  className="carts-view-wallet-upper-cards-left-card-right-card-content-top-up"
                  onClick={handleOpenModal}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon icon={faArrowUpFromBracket} />
                  <h5>Top Up</h5>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
          <Row>
            <div className="wallet-progress-bar-container">
              <div
                className="wallet-progress-bar"
                style={{
                  width: `${(walletData?.purchaseWalletBalance / 5000) * 100}%`,
                  backgroundColor: "#4dabf7",
                }}
              ></div>
            </div>
          </Row>
          <Row>
            <Col lg={12}>
              <Card className="carts-view-wallet-upper-cards-right-card">
                <CardBody className="fw-bold">
                  <Row className="d-flex justify-content-between align-items-center">
                    <Col>Cash Sales</Col>
                    <Col className="text-end">
                      {isWalletDataLoading
                        ? "Loading..."
                        : `LKR ${walletData?.salesWalletBalance?.cashSales ?? 0}`}
                    </Col>
                  </Row>
                  <Row>
                    <Col>Credit & Sales</Col>
                    <Col className="text-end">
                      {isWalletDataLoading
                        ? "Loading..."
                        : `LKR ${walletData?.salesWalletBalance?.creditCardSales ?? 0}`}
                    </Col>
                  </Row>
                  <Row>
                    <Col>Your Earnings</Col>
                    <Col className="text-end">
                      {isWalletDataLoading
                        ? "Loading..."
                        : `LKR ${walletData?.salesWalletBalance?.myEarnings ?? 0}`}
                    </Col>
                  </Row>
                  {walletDataError && <p>Error loading wallet data</p>}
                </CardBody>
              </Card></Col>
          </Row></>)}
      <Modal show={isModalOpen} onHide={handleCloseModal} centered>
        <form onSubmit={handleUpdateWalletDetails}>
          <Modal.Header closeButton>
            <Modal.Title>Add Money</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <label className="form-label">Amount:</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="d-flex align-items-center gap-2 mb-3">
              <label className="form-label">Remarks:</label>
              <input type="text" className="form-control" placeholder="Optional" />
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex align-items-center justify-content-center">
            {isSaving ? (
              <ButtonComponent titel="Saving" isDisabled={true} icon={<FontAwesomeIcon icon={faSpinner} spin />} />
            ) : <ButtonComponent titel="Confirm" type="submit" isDisabled={isSaving} />}
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default Wallet;
